/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

interface ICheckboxLabelProps {
  label: string;
  value?: boolean;
  color?: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" | undefined;
  checked?: boolean | undefined
  onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
  name?: string | undefined;
  disabled?: boolean | undefined;
}

const CheckboxLabel: React.FC<ICheckboxLabelProps> = ({ label, value, color, onChange, checked, name, disabled }) => {
  // const [checkValue, setCheckValue] = useState(value);
  // const handleOnCahange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setCheckValue(e.target.checked);
  // };

  // useEffect(() => {
  //   setCheckValue(value);
  // }, [value]);

  return (
    <FormGroup>
      <FormControlLabel
        label={label}
        disabled={disabled}
        control={
          <Checkbox
            value={value}
            name={name}
            color={color}
            checked={checked}
            onChange={onChange}
          />
        }
      />
    </FormGroup>
  );
};

export default CheckboxLabel;
